import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=38b583e0"
import script from "./AddressBlock.vue?vue&type=script&lang=js"
export * from "./AddressBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports